import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../components/TopNav';
import ComposeModal from '../components/ComposeModal';
import Footer from '../components/Footer';
import { postsAPI, platformsAPI } from '../api';
import './Dashboard.css';

const Dashboard = () => {
  const [isComposeModalOpen, setIsComposeModalOpen] = useState(false);

  useEffect(() => {
    // Diagram requirement: dashboard init verifies connected platforms.
    // No UI dependency here; this warms the backend capability cache.
    const token = localStorage.getItem('token');
    if (!token) return;
    platformsAPI.getConnections().catch(() => {
      // Intentionally ignore; dashboard should still render
    });
  }, []);

  const handleComposeClick = () => {
    setIsComposeModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsComposeModalOpen(false);
  };

  const handleSubmitPost = async (postData, postId = null) => {
    try {
      if (postId) {
        await postsAPI.update(postId, postData);
      } else {
        const response = await postsAPI.create(postData);
        console.log('Post created:', response);
      }
      // You can add a success notification here
    } catch (error) {
      console.error('Error saving post:', error);
      throw error;
    }
  };

  const hubCards = [
    { title: 'Content Calendar', description: 'Plan & manage posts', link: '/scheduler' },
    { title: 'Unified Inbox', description: 'Messages and Comments', link: '/inbox' },
    { title: 'Analytics', description: 'Track growth & performance', link: '/analytics' },
    { title: 'AI Assist', description: 'Ideas, captions, scripts', link: '#' },
    { title: 'Listening', description: 'Monitor keywords & mentions', link: '/listening' },
    { title: 'Settings', description: 'Account & configuration', link: '/settings' }
  ];

  return (
    <div className="dashboard-page">
      <TopNav activePage="dashboard" onComposeClick={handleComposeClick} />

      {/* MAIN CONTENT */}
      <main className="content">
        {/* QUICK GREETING + SEARCH */}
        <section className="header-section">
          <h1>Welcome back 👋</h1>
          <input type="text" className="search" placeholder="Search across Trckle…" />
        </section>

        {/* QUICK ACTIONS */}
        <section className="quick-actions">
          <button className="btn primary" onClick={handleComposeClick}>Compose Post</button>
          <button className="btn">Upload Media</button>
          <button className="btn">AI Caption</button>
        </section>

        {/* CENTRAL HUB GRID */}
        <section className="hub-grid">
          {hubCards.map((card, index) => (
            <Link key={index} to={card.link} className="hub-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </Link>
          ))}
        </section>
      </main>

      <ComposeModal 
        isOpen={isComposeModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitPost}
      />
      <Footer />
    </div>
  );
};

export default Dashboard;
